export const lendingClubPalette = {
    default: {
        white: '#FFFFFF',
        black: '#000000',
    },
    gray: {
        '25': '#FAFCFC',
        '50': '#E4EBEB',
        '100': '#CDDADB',
        '200': '#B6C8CB',
        '300': '#9FB6BB',
        '400': '#88A3AB',
        '500': '#708F9B',
        '600': '#597B8C',
        '700': '#41677C',
        '800': '#29516D',
        '900': '#113B5E',
    },
    primary: {
        '25': '#F7FBFD',
        '50': '#EEF8FB',
        '100': '#DDF1F7',
        '200': '#C4E6F1',
        '300': '#82CDE5',
        '400': '#66B9DB',
        '500': '#3398CC',
        '600': '#0077B3',
        '700': '#006099',
        '800': '#004880',
        '900': '#003166',
    },
    error: {
        '25': '#FFFBFA',
        '50': '#FEF3F2',
        '100': '#FEE4E2',
        '200': '#FECDCA',
        '300': '#FDA29B',
        '400': '#F97066',
        '500': '#F04438',
        '600': '#D92D20',
        '700': '#B42318',
        '800': '#912018',
        '900': '#7A271A',
    },
    warning: {
        '25': '#FFFCF5',
        '50': '#FFFAEB',
        '100': '#FEF0C7',
        '200': '#FEDF89',
        '300': '#FEC84B',
        '400': '#FDB022',
        '500': '#F79009',
        '600': '#DC6803',
        '700': '#B54708',
        '800': '#93370D',
        '900': '#7A2E0E',
    },
    success: {
        '25': '#F6FEF9',
        '50': '#ECFDF3',
        '100': '#D1FADF',
        '200': '#A6F4C5',
        '300': '#6CE9A6',
        '400': '#32D583',
        '500': '#12B76A',
        '600': '#039855',
        '700': '#027A48',
        '800': '#05603A',
        '900': '#054F31',
    },
    logoRed: '#EA4224',
    turquoise: {
        '300': '#CEECF3',
        '400': '#80D2E5',
        '500': '#2EB7D6',
        '600': '#32A6C0',
    },
    emerald: {
        '300': '#BEE5BB',
        '400': '#77CA7F',
        '500': '#42AF5A',
        '600': '#329648',
    },
    peridot: {
        '300': '#DCF2CA',
        '400': '#B9E194',
        '500': '#9BCA63',
        '600': '#7CAD4D',
    },
    sunstone: {
        '300': '#FAFAA9',
        '400': '#E9EA7A',
        '500': '#D6D765',
        '600': '#BEBF41',
    },
    citrine: {
        '300': '#F3CD6C',
        '400': '#EEBB3A',
        '500': '#EAAA08',
        '600': '#CD8B1C',
    },
    amber: {
        '300': '#F9DFCE',
        '400': '#EDA16D',
        '500': '#E56721',
        '600': '#C45616',
    },
    morganite: {
        '300': '#FAE3E2',
        '400': '#F5C8C6',
        '500': '#F1ADAA',
        '600': '#ED938E',
    },
    fuchsia: {
        '300': '#FADEEC',
        '400': '#F5BAD7',
        '500': '#E968A8',
        '600': '#C73883',
    },
    amethyst: {
        '300': '#D0B4DF',
        '400': '#B590C9',
        '500': '#9E6CBB',
        '600': '#7D449E',
    },
    base: {
        white: '#FFFFFF',
        '25': '#F7F7F7',
        '50': '#EDEDED',
        '100': '#DDDDDD',
        '200': '#D4D4D4',
        '300': '#ACACAC',
        '400': '#7E7E7E',
        '500': '#606060',
        '600': '#404040',
        '700': '#252527',
        '800': '#111111',
        '900': '#000000',
    },
};
